require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./personal-electronic-banking.json") })
        }
      }, "path---personal-electronic-banking");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---personal-electronic-banking!./.cache/json/personal-electronic-banking.json
// module id = 2671
// module chunks = 231608221292675